module.exports = __webpack_public_path__ + "img/KBANK.8ce9c5bf.png";